import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { googleClickRichTextEvent } from '../../../../../utils/analytics';
import { TCellTextProps } from '../../../types/index.types';

const CellText: FC<TCellTextProps> = (props): JSX.Element | null => {
  const { index, row, heading, eyebrow, fadeIn, hideCell } = props;

  const data = row.getCellData(index);

  if (!data?.value) return null;

  return (
    <RichText
      field={data}
      editable={true}
      className={`
        rich-text
        model-detail-specification-table__spec 
        model-detail-specification-table__cell-animation
        ${fadeIn ? 'model-detail-specification-table__cell-animation--show-animation' : ''}
        ${hideCell ? 'model-detail-specification-table__cell-animation--hide' : ''}
      `}
      onClick={(event) => googleClickRichTextEvent(event, heading?.value ?? eyebrow?.value)}
    />
  );
};

export default CellText;
